import React, { useEffect, useState } from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link, useLocation } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { all_routes } from '../../router/all_routes';
import { useGetTopScholarshipsFilterApiQuery } from '../../../core/Features/api/findACourse/scholarships/scholarships';
import Pagination from '../../StudyDestination/Australia/Pagination';
import { useSelector } from 'react-redux';


interface BannerProps {
    apiValues: any;
}



const Whatsnew: React.FC<BannerProps> = ({ apiValues }) => {


    const reduxValue = useSelector((state: any) => state?.common?.commonData?.filterLevelandDesti)
    console.log("reduxValue", reduxValue)

    //     const studyLevelIds = ["64fabc123", "64fabc456"];
    // const destinationIds = ["64def123", "64def456"];


    // fetch(`/api/scholarships/filter?${queryParams}`)
    //   .then(res => res.json())
    //   .then(data => console.log(data));




    const location = useLocation();
    const queryParams2 = new URLSearchParams(location.search);

    const subjectId = queryParams2.get('subjectId');
    const courseID = queryParams2.get('courseID');
    const otherData = queryParams2.get('otherData');

    // const { subjectId, courseID, otherData } = location.state || {};
    // console.log("Subject Name:", subjectId);
    // console.log("Course ID:", courseID);
    // console.log("Other Data:", otherData);

    const [page, setPage] = useState(1);
    const limit = 3; // item per page

    const queryParams = [
        `studyLevelIds=${reduxValue?.levels?.join(",")}`,
        `destinationIds=${reduxValue?.countries?.join(",")}`,
        `page=${page}`,
        `limit=${limit}`
    ].join("&");

    const { data: availableScholarshipsSubject, isLoading, isError } = useGetTopScholarshipsFilterApiQuery(queryParams);

    const universities = availableScholarshipsSubject?.data || [];

    const totalItems = availableScholarshipsSubject?.totalItems || 0; // Total count from backend
    const totalPages = Math.ceil(availableScholarshipsSubject?.totalPages)

    const route = all_routes;

    const [selectedItems, setSelectedItems] = useState<boolean[]>([]);

    useEffect(() => {
        if (availableScholarshipsSubject?.length) {
            setSelectedItems(Array(availableScholarshipsSubject?.length).fill(false));
        }
    }, [availableScholarshipsSubject]);

    const handleItemClick = (index: number) => {
        setSelectedItems((prev) => {
            const updated = [...prev];
            updated[index] = !updated[index];
            return updated;
        });
    };

    const whatsnewslider = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* whats new */}
            <div className="feature-section position-relative">
                <div className="container">
                    <ImageWithBasePath
                        src="assets/img/bg/feature-bg-01.png"
                        alt="img"
                        className="bg-star-01 img-fluid"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/feature-bg-02.png"
                        alt="img"
                        className="bg-star-02 img-fluid"
                    />

                    <div
                        className="d-flex align-items-center justify-content-center flex-wrap gap-3 aos flex-column flex-md-row text-center text-md-start"

                    >

                        <div></div>
                        <div className="section-header text-center aos" >
                            <span className="section-badge">
                                {apiValues?.scholarship?.scholarShipsListaboveTitle}
                            </span>
                            <h2>
                                {apiValues?.scholarship?.scholarShipsListaboveDesc}
                            </h2>
                            <p>
                                {apiValues?.scholarship?.scholarShipsListabovemini}
                            </p>
                        </div>
                        {/* <div className='md:mb-5'>
                            <Link to="#" className="btn btn-sm btn-primary" style={{
                                backgroundColor: '#1D1753',
                                borderColor: '#6f42c1',
                                width: '120px'
                            }}>
                                View All
                            </Link>
                        </div> */}
                    </div>



                    <div className='row mt-5'>

                        {

                            (Array.isArray(universities) ? universities : []).map((univ: any, index: number) => {
                                return (


                                    <div className="col-md-4 item" key={univ._id || index}>
                                        <div className="course-item-two course-item">
                                            <div className="course-img">

                                                <div className="position-absolute start-0 top-0 d-flex align-items-start w-100 z-index-2 p-2">

                                                </div>
                                            </div>

                                            <div className="course-content">
                                                <div className="ms-2">
                                                    <h5 className="subs-title mb-3">{univ?.scholarshipTitle}</h5>
                                                    <p className="mb-2">{univ?.scholarshipUniversity?.title}</p>
                                                </div>
                                            </div>

                                            <div className="border-bottom w-100 mb-3" />
                                            {
                                                (Array.isArray(univ?.scholarShipPoints) ? univ?.scholarShipPoints : []).map((item: any, index: number) => {

                                                    return (
                                                        <p className="flex items-center gap-1">
                                                            <ImageWithBasePath
                                                            style={{
                                                                height:"40px",
                                                                width:"40px"
                                                            }}
                                                                className="me-2  rounded-full"
                                                                source={item?.iconUrl}
                                                                alt="img"
                                                            />
                                                            {item?.pointTitle}
                                                        </p>
                                                    )
                                                }) || []
                                            }



                                            <div className="d-flex align-items-center justify-content-center p-3">
                                                <Link
                                                    to={`${route.IndividualSholarShip}/${univ._id}`}
                                                    className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center text-center"
                                                    style={{ width: '200px', padding: '10px' }}
                                                >
                                                    View Details
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                )

                            }) || []

                        }

                    </div>

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div className="py-6 flex justify-center cursor-pointer">
                            <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
                        </div>
                    )}
                </div>
            </div>
            {/* /whats new */}
        </>

    )
}

export default Whatsnew
